<template>
  <div>
    <ca-heading :text="titleMixin" />

    <ca-page>
      <ca-form
        :key="formKey"
        :on-submit="onSubmit">
        <worker-contract-info-form
          :contract-info="contractInfo"
          @refresh-form="refreshForm"></worker-contract-info-form>
        <worker-form-footer :on-back="goBack"></worker-form-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { initFormObject } from 'packages/common/utils';
import WorkerContractInfoForm from './WorkerContractInfoForm';
import WorkerFormFooter from '../WorkerFormFooter';
import {
  hasWorkerDraft,
  getWorkerDraft,
  setWorkerDraft,
} from '../../workersService';
import { hasContractInfoDraft } from './workerContractInfoService';
import { workerFormMixin } from '../../mixins/WorkerFormMixin';
import { clickToGoWorkerShiftInfoPage } from '../../workerTrackerService';

export default {
  name: 'WorkerContractInfoFormPage',
  components: {
    WorkerContractInfoForm,
    WorkerFormFooter,
  },
  mixins: [workerFormMixin],
  props: {
    previousStep: Function,
    nextStep: Function,
  },
  data() {
    return {
      formKey: 0,
      contractInfo: {
        ...initFormObject([
          { contractType: 'I' },
          { admissionType: 'A' },
          { admissionIndicator: 'N' },
          { temporaryLegalType: 'N' },
          { temporaryInclusion: 'L' },
          { salaryUnit: 'M' },
        ]),
        fgts: true,
        dsr: true,
        temporary: false,
        unionContribution: false,
        canChangeSalary: true,
      },
    };
  },
  computed: {
    workerBasicInfo() {
      return getWorkerDraft();
    },
    misc() {
      return this.$store.state.misc;
    },
  },
  created() {
    if (!hasWorkerDraft()) {
      this.$emit('on-reset-steps');
    } else {
      this.initData();
    }
  },
  methods: {
    async initData() {
      const { basicInfo: { name } } = this.workerBasicInfo;
      this.$store.dispatch('breadcrumb/setBreadcrumbProps', { workerName: name });

      if (hasContractInfoDraft()) {
        this.setContractInfo();
      }
    },
    async setContractInfo() {
      this.contractInfo = this.workerBasicInfo.contractInfo;
    },
    goBack() {
      this.previousStep();
    },
    refreshForm() {
      this.formKey++;
    },
    onSubmit() {
      clickToGoWorkerShiftInfoPage();
      setWorkerDraft({ contractInfo: this.contractInfo });
      return this.nextStep();
    },
  },
};
</script>
